// Written in this round about way for babel-transform-imports
import generatePath from "react-router/es/generatePath";

export default generatePath;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/generatePath.js
// module id = 75
// module chunks = 0